<template>
  <account-setting-two-factor />
</template>

<script>
import AccountSettingTwoFactor from '@/views/pages/account-setting/AccountSettingTwoFactor.vue'

export default {
  components: {
    AccountSettingTwoFactor,
  },
}
</script>
